import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: '#EE6A1F' }} className="text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">SKYHIGH Adventures</h3>
            <p className="text-gray-200 mb-4">
              Pioneers of hot air ballooning across Uganda since 1976
            </p>
            <p className="text-sm text-gray-300">By Brenda J. Bakiza</p>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="font-semibold mb-3">NAIROBI - HEAD OFFICE</h4>
            <div className="space-y-2 text-gray-200">
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+254 (0) 731 701 761</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+254 (0) 705 721 462</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>info@skyhighadventures.co.ke</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/the-adventure" className="block text-gray-200 hover:text-white transition-colors">
                The Adventure
              </Link>
              <Link to="/our-pilots" className="block text-gray-200 hover:text-white transition-colors">
                Our Pilots
              </Link>
              <Link to="/our-balloons" className="block text-gray-200 hover:text-white transition-colors">
                Our Balloons
              </Link>
              <Link to="/contact" className="block text-gray-200 hover:text-white transition-colors">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="font-semibold mb-3">Follow Us</h4>
            <p className="text-sm text-gray-100 mb-4">
              Join our adventures across Uganda and see the latest balloon journeys.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full bg-white/20 hover:bg-white/40 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full bg-white/20 hover:bg-white/40 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-full bg-white/20 hover:bg-white/40 transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-gray-300 text-sm">
          <p>&copy; {new Date().getFullYear()} SKYHIGH Adventures. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
